import * as actionTypes from "Redux/Actions/actionTypes";

export const addLoanLiabilities = (
  applicantId,
  finAnalysisId,
  payLoad,
  callback = () => {}
) => ({
  type: actionTypes.LOAN_ADD_LIABILITIES,
  data: {
    applicantId,
    finAnalysisId,
    payLoad,
  },
  callback,
});

// TODO update (has third param)
export const updateLoanLiabilities = (
  applicantId,
  finAnalysisId,
  financialId,
  payLoad,
  callback = () => {}
) => ({
  type: actionTypes.LOAN_UPDATE_LIABILITIES,
  data: {
    applicantId,
    finAnalysisId,
    financialId,
    payLoad,
  },
  callback,
});

export const getLoanLiabilities = (
  applicantId,
  finAnalysisId,
  financialId,
  callback = () => {}
) => ({
  type: actionTypes.LOAN_GET_LIABILITIES,
  data: {
    applicantId,
    finAnalysisId,
    financialId,
  },
  callback,
});
